// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2508) return "css/2508-fcf709e1890ff4fc4a91.css";
	if (chunkId === 2899) return "css/2899-1a00ff129e80224d0433.css";
	// return url for filenames based on template
	return "css/" + (chunkId === 7395 ? "design_system" : chunkId) + "-" + {"4955":"26df6bfbbb1076dde711","7395":"282edc2aa6b573b6fafc"}[chunkId] + ".css";
};